module.exports = __webpack_public_path__ + "media/images/amenities_icons/makerspace-d4f37daa25b56f551857ac5ca9298069.svg";